<template>
    <div class="tachogragh-svg">
        <svg viewBox="0 0 900 150">
            <g transform="translate(10,0)">
                <g transform="scale(0.5,-1) translate(0,-100)">
                    <template v-for="(rect,index) in rects">
                        <rect :x="rect.x" :key="index" :fill="rect.fill" :width="rect.width" :height="rect.height"></rect>
                    </template>
                </g>
                <g style="text-anchor:middle;font-size:14px;">
                    <text x="0" y="123">0</text>
                    <text x="30" y="123">1</text>
                    <text x="60" y="123">2</text>
                    <text x="90" y="123">3</text>
                    <text x="120" y="123">4</text>
                    <text x="150" y="123">5</text>
                    <text x="180" y="123">6</text>
                    <text x="210" y="123">7</text>
                    <text x="240" y="123">8</text>
                    <text x="270" y="123">9</text>
                    <text x="300" y="123">10</text>
                    <text x="330" y="123">11</text>
                    <text x="360" y="123">12</text>
                    <text x="390" y="123">13</text>
                    <text x="420" y="123">14</text>
                    <text x="450" y="123">15</text>
                    <text x="480" y="123">16</text>
                    <text x="510" y="123">17</text>
                    <text x="540" y="123">18</text>
                    <text x="570" y="123">19</text>
                    <text x="600" y="123">20</text>
                    <text x="630" y="123">21</text>
                    <text x="660" y="123">22</text>
                    <text x="690" y="123">23</text>
                    <text x="720" y="123">24</text>
                    <text x="360" y="142">Günün Saatleri</text>
                </g>
                <g style="stroke:var(--gray);stroke-width:2;">
                    <line x1="0" y1="100" x2="0" y2="104" />
                    <line x1="30" y1="100" x2="30" y2="104" />
                    <line x1="60" y1="100" x2="60" y2="104" />
                    <line x1="90" y1="100" x2="90" y2="104" />
                    <line x1="120" y1="100" x2="120" y2="104" />
                    <line x1="150" y1="100" x2="150" y2="104" />
                    <line x1="180" y1="100" x2="180" y2="104" />
                    <line x1="210" y1="100" x2="210" y2="104" />
                    <line x1="240" y1="100" x2="240" y2="104" />
                    <line x1="270" y1="100" x2="270" y2="104" />
                    <line x1="300" y1="100" x2="300" y2="104" />
                    <line x1="330" y1="100" x2="330" y2="104" />
                    <line x1="360" y1="100" x2="360" y2="104" />
                    <line x1="390" y1="100" x2="390" y2="104" />
                    <line x1="420" y1="100" x2="420" y2="104" />
                    <line x1="450" y1="100" x2="450" y2="104" />
                    <line x1="480" y1="100" x2="480" y2="104" />
                    <line x1="510" y1="100" x2="510" y2="104" />
                    <line x1="540" y1="100" x2="540" y2="104" />
                    <line x1="570" y1="100" x2="570" y2="104" />
                    <line x1="600" y1="100" x2="600" y2="104" />
                    <line x1="630" y1="100" x2="630" y2="104" />
                    <line x1="660" y1="100" x2="660" y2="104" />
                    <line x1="690" y1="100" x2="690" y2="104" />
                    <line x1="720" y1="100" x2="720" y2="104" />
                    <polyline points="0,0 720,0 720,100 0,100 0,0" style="fill:none;" />
                </g>
                <g style="text-anchor:left;font-size:14px;">
                    <rect x="740" y="100" fill="var(--primary)" width="30" height="16" /><text x="775" y="114"> = unknown</text>
                    <rect x="740" y="80" fill="var(--danger)" width="30" height="16" /><text x="775" y="94"> = break/rest</text>
                    <rect x="740" y="60" fill="var(--secondary)" width="30" height="16" /><text x="775" y="74"> = short/break</text>
                    <rect x="740" y="40" fill="var(--warning)" width="30" height="16" /><text x="775" y="54"> = working</text>
                    <rect x="740" y="20" fill="var(--success)" width="30" height="16" /><text x="775" y="34"> = driving</text>
                    <rect x="740" y="0" fill="var(--dark)" width="30" height="16" /><text x="775" y="14"> = available</text>
                    <rect x="740" y="120" fill="#d0d0d0" width="30" height="16" /><text x="775" y="134"> = boş/veri yok</text>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    props:{
        json:{
            type:Array,
            default:()=>[]
        }
    },
    computed:{
        rects(){
            let rects = []
            if(this.json){
                for(let index = 0; index < this.json.length; index++){
                    let thisRect = this.json[index]
                    let x, fill, width, height, variant;
                    switch (thisRect.Activity) {
                        case 'Break':
                            fill = 'var(--danger)';
                            variant = 'danger';
                            height = 24;
                        break;
                        case 'Driving':
                            fill = 'var(--success)';
                            variant = "success"
                            height = 80;
                        break;
                        case 'Work':
                            fill = 'var(--warning)';
                            variant = "warning";
                            height = 55;
                        break;
                        case 'Available':
                            fill = 'var(--gray)';
                            variant = "dark"
                            height = 16;
                        break;
                        case 'NoData':
                            fill = '#d0d0d0';
                            variant = "light"
                            height = 16;
                        break;
                        default:
                            fill = 'var(--primary)';
                            variant = "primary"
                            height = 16;
                        break;
                    }
                    if(thisRect.Status == "0" && thisRect.Inserted == "False"){
                        fill = 'var(--primary)'
                        variant = "primary"
                        height = 16
                    }
                    let time = thisRect.Time.split(':')
                    x = (parseInt(time[0])*60) + parseInt(time[1])
                    let nextRect = this.json[index + 1]
                    if(nextRect != null){
                        let nextTime = nextRect.Time.split(':')
                        width = (parseInt(nextTime[0]) * 60) + parseInt(nextTime[1]) - x
                    }else {
                        width = 1439 - x
                    }
                    if(fill == 'red' && width < 15){
                        fill = 'var(--secondary)'
                        variant = "secondary"
                        height = 32
                    }
                    let thisRectObj = {x,fill,height,width,variant,time:thisRect.Time,activity:thisRect.Activity}
                    rects.push(thisRectObj)
                }
            }
            return rects
        }
    }
}
</script>

<style>
.tachogragh-svg{
    font-size: 14px;
}
</style>